<template>
    <div class="border border-gray-200 rounded-md text-sm">
        <table class="w-full">
            <tbody class="divide-y divide-gray-200">
                <tr v-for="material in materials" :key="material.id">
                    <td class="px-4 py-3 align-middle break-words">{{ material.name }}</td>
                    <td class="px-4 py-3 align-middle whitespace-nowrap font-mono font-semibold w-px">{{ material.quantity }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        materials: Array
    },
}
</script>
